/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export enum AudioId {
		lo = 'sound/tone440.wav',
		hi = 'sound/tone880.wav',
		slider = 'sound/slider.wav',
	}
}
